<template>
  <el-popover
      ref="periodPopover"
      placement="bottom-start"
      trigger="click"
      @show="onPopoverShow"
      popper-class="account-period-popover"
      :popper-options="{ boundariesElement: 'viewport' }"
  >
    <!-- 弹出层内容：会计期间选择表单 -->
    <div class="account-period-form">
      <div class="form-header">
        <h3>会计期间选择</h3>
        <el-button
            icon="el-icon-close"
            size="mini"
            class="close-btn"
            @click="handleCancel"
        />
      </div>

      <div class="form-content">
        <div class="form-item">
          <label class="form-label">会计期间：</label>
          <div class="form-control">
            <el-date-picker
                v-model="startMonth"
                type="month"
                placeholder="起始月"
                style="width: 120px"
                @change="handleDateChange"
                class="date-picker"
                :clearable="false"
                required
            />
            <span class="to">至</span>
            <el-date-picker
                v-model="endMonth"
                type="month"
                placeholder="结束月"
                style="width: 120px"
                @change="handleDateChange"
                class="date-picker"
                :clearable="false"
                required
            />
          </div>
        </div>

        <!-- 科目标签 -->
        <div class="form-item">
          <label class="form-label">科　　目：</label>
          <div class="form-control">
            <el-autocomplete
                v-model="subjectCode"
                :fetch-suggestions="querySubject"
                placeholder="请输入起始科目"
                @select="handleSubjectSelect"
                @clear="handleSubjectClear"
                @input="handleSubjectInput"
                @focus="handleSubjectFocus"

                class="subject-input-width"
                ref="subjectAutocomplete"
                :trigger-on-focus="false"
                :popper-append-to-body="false"
                :popper-class="`subject-popper ${isSubjectSelected ? 'subject-selected' : ''}`"
            >
              <template slot-scope="{ item }">
                <div class="subject-option">
                  <span class="subject-option__code">{{ item.subjectCode }}</span>
                  <span class="subject-option__name">{{ item.subjectFullName }}</span>
                </div>
              </template>
            </el-autocomplete>
          </div>
        </div>

        <!-- 摘要标签 -->
        <div class="form-item">
          <label class="form-label">摘　　要：</label>
          <div class="form-control">
            <el-input v-model="summary" placeholder="请输入摘要关键词" />
          </div>
        </div>

        <div class="form-item">
          <label class="form-label">排序方式：</label>
          <div class="form-control radio-group">
            <el-radio v-model="sortType" label="voucherNo">凭证号排序</el-radio>
            <el-radio v-model="sortType" label="voucherDate">凭证日期排序</el-radio>
          </div>
        </div>
      </div>

      <div class="form-actions">
        <el-button
            type="primary"
            @click="handleConfirm"
            class="action-btn confirm-btn"
        >
          确定
        </el-button>
        <el-button
            @click="handleCancel"
            class="action-btn cancel-btn"
        >
          取消
        </el-button>
        <el-button
            @click="handleReset"
            class="action-btn reset-btn"
        >
          重置
        </el-button>
      </div>
    </div>

    <!-- 触发弹出层的元素 -->
    <div
        slot="reference"
        class="green-date-display"
    >
      <i class="fa fa-caret-left"></i>
      {{ displayDate }}
      <i class="fa fa-caret-right"></i>
    </div>
  </el-popover>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    currentSubject: {
      type: Object,
      default: () => null, // 结构：{ id, code, name, subjectFullName }
      required: false
    },
    subjectList: {
      type: Array,
      default: () => [] // 默认空数组
    },
  },
  computed: {
    ...mapState(['currentAccountSets', 'User']),
    checkDateObject() {
      let data = {};
      this.User.checkoutList.forEach(item => {
        if (!data[item.checkYear]) {
          data[item.checkYear] = [];
        }
        data[item.checkYear].push(item.checkMonth);
      });
      Object.keys(data).forEach((value) => {
        data[value] = data[value].sort((a, b) => a - b);
      });
      return data;
    },
    years() {
      return Object.keys(this.checkDateObject).sort((a, b) => b - a);
    },
    isSubjectSelected() {
      return !!this.selectedSubject;
    }
  },

  data() {
    const defaultDate = new Date();
    return {
      startMonth: null,
      endMonth: null,
      subjectCode: '',
      startLevel: 1,
      endLevel: 4,
      summary: '',
      sortType: 'voucherNo',
      showAuxiliary: false,
      onlyLeaf: false,
      showOpposite: false,
      hideZero: false,
      hideZeroNoOccur: false,
      hideNoOccurTotal: false,
      displayDate: null,
      subjectOptions: [],
      selectedSubject: null,
      allSubjects: [

      ]
    };
  },

  methods: {
    getFirstDayOfMonth() {
      const now = new Date();
      // 构造当月1号：年、月、日=1
      return new Date(now.getFullYear(), now.getMonth(), 1);
    },
    handleSubjectClear() {
      const subjectAutocomplete = this.$refs.subjectAutocomplete;
      if (!subjectAutocomplete) return;

      // 重置数据
      this.subjectCode = '';
      this.selectedSubject = null;
      this.subjectOptions = [];

      // 清除后显示提示框
      this.$nextTick(() => {
        const inputElement = subjectAutocomplete.$refs.input;
        if (inputElement) {
          inputElement.focus();
        }

        this.querySubject('', (results) => {
          subjectAutocomplete.suggestions = results;
          subjectAutocomplete.visible = true;
          subjectAutocomplete.$forceUpdate();
        });
      });
    },

    handleSubjectInput(val) {
      // 移除判断条件，无论是否选中都显示提示
      this.querySubject(val, (results) => {
        if (this.$refs.subjectAutocomplete) {
          this.$refs.subjectAutocomplete.suggestions = results;
          this.$refs.subjectAutocomplete.visible = true;
        }
      });
    },

    handleSubjectFocus() {
      // 移除判断条件，无论是否选中都显示提示
      this.querySubject('', (results) => {
        this.$nextTick(() => {
          if (this.$refs.subjectAutocomplete) {
            this.$refs.subjectAutocomplete.suggestions = this.allSubjects;
            this.$refs.subjectAutocomplete.visible = true;
            // 强制更新提示框显示状态
            this.$refs.subjectAutocomplete.$forceUpdate();
          }
        });
      });
    },

    querySubject(queryString, cb) {
      let results = [];
      if (!queryString || !queryString.trim()) {
        results = [...this.allSubjects];
      } else {
        const query = queryString.toLowerCase();
        results = this.allSubjects.filter(item =>
            item.subjectCode.toLowerCase().includes(query) ||
            item.subjectName.toLowerCase().includes(query)
        );
      }

      this.subjectOptions = results;
      cb(results);
    },

    handleSubjectSelect(item) {
      this.selectedSubject = item;
      this.subjectCode = `${item.subjectCode} ${item.subjectName}`;

      /*this.$emit('subject-select', {
        id: item.id,
        code: item.subjectCode,
        name: item.subjectName,
        subjectFullName: item.subjectFullName || item.subjectName
      });*/

      this.$nextTick(() => {
        const subjectAutocomplete = this.$refs.subjectAutocomplete;
        if (subjectAutocomplete) {
          // 选中后不立即隐藏，等待用户操作
          subjectAutocomplete.suggestions = [];
          if (subjectAutocomplete.$refs.input) {
            subjectAutocomplete.$refs.input.blur();
          }
        }
      });
    },

    // 以下所有方法保持不变
    handleDateChange() {
      const startDate = typeof this.startMonth === "string" ? this.parseDateStrToDate(this.startMonth) : this.startMonth;
      const endDate = typeof this.endMonth === "string" ? this.parseDateStrToDate(this.endMonth) : this.endMonth;
      const normalizedStart = new Date(startDate.getFullYear(), startDate.getMonth(), 1, 0, 0, 0, 0);
      const normalizedEnd = new Date(endDate.getFullYear(), endDate.getMonth(), 1, 0, 0, 0, 0);
      let finalStart, finalEnd;
      if (normalizedStart > normalizedEnd) {
        // 当start大于end时，互换值
        finalStart = normalizedEnd;
        finalEnd = normalizedStart;

      } else {
        // 否则使用原始值
        finalStart = normalizedStart;
        finalEnd = normalizedEnd;
      }
      this.startMonth = finalStart;
      this.endMonth = finalEnd;
      this.$emit('date-change', {
        startMonth: this.formatDateForApi(finalStart),
        endMonth: this.formatDateForApi(finalEnd)
      });


      const startStr = this.formatDate(finalStart);
      const endStr = this.formatDate(finalEnd);
      this.displayDate = startStr === endStr ? startStr : `${startStr}—${endStr}`;
      console.log("选择的开始月份zzz：", this.startMonth, "选择的结束月份zzz：", this.endMonth);
    },

    syncEndMonth() {
      if (this.startMonth && !this.endMonth) {
        this.endMonth = this.startMonth;
      } else if (this.startMonth > this.endMonth) {
        this.endMonth = this.startMonth;
      }
    },

    onPopoverShow() {
      if (!this.startMonth) {
        const defaultDate = new Date();
        this.startMonth = defaultDate;
        this.endMonth = defaultDate;
        this.handleDateChange();
      }
    },

    handleCancel() {
      if (this.$refs.periodPopover) {
        this.$refs.periodPopover.doClose();
      }
    },

    handleReset() {
      this.subjectCode = '';
      this.selectedSubject = null;
      this.subjectOptions = [];
      this.summary = '';
      this.sortType = 'voucherNo';

      const defaultDate = new Date();
      this.startMonth = defaultDate;
      this.endMonth = defaultDate;
      this.handleDateChange();
    },

    parseDateStrToDate(dateStr) {
      if (!dateStr) return new Date();
      const [year, month, day] = dateStr.split("-").map(Number);
      return new Date(year, month - 1, day);
    },

    formatDate(date) {
      const targetDate = typeof date === "string" ? this.parseDateStrToDate(date) : date;
      const year = targetDate.getFullYear();
      const month = String(targetDate.getMonth() + 1).padStart(2, "0");
      return `${year}年${month}月`;
    },

    formatDateForApi(date) {
      const targetDate = typeof date === "string" ? this.parseDateStrToDate(date) : date;
      const year = targetDate.getFullYear();
      const month = String(targetDate.getMonth() + 1).padStart(2, "0");
      return `${year}-${month}`;
    },

    // ========== 只修改这个方法 ==========
    handleConfirm() {
      if (!this.startMonth || !this.endMonth) {
        this.$message.error('会计期间不能为空，请选择完整的日期范围');
        return;
      }
      const startDate = typeof this.startMonth === "string" ? this.parseDateStrToDate(this.startMonth) : this.startMonth;
      const endDate = typeof this.endMonth === "string" ? this.parseDateStrToDate(this.endMonth) : this.endMonth;
      // 强制设置为每月1号
      const normalizedStart = new Date(startDate.getFullYear(), startDate.getMonth(), 1, 0, 0, 0, 0);
      const normalizedEnd = new Date(endDate.getFullYear(), endDate.getMonth(), 1, 0, 0, 0, 0);

      if (normalizedStart > normalizedEnd) {
        this.$message.warning('结束月份不能早于起始月份');
        return;
      }

      // 构建完整参数：包含日期、科目、摘要、排序方式
      const params = {
        startMonth: this.formatDateForApi(normalizedStart),
        endMonth: this.formatDateForApi(normalizedEnd),
        // 新增：传递完整的科目数据（id、code、name），而非仅code
        subject: this.selectedSubject ? {
          id: this.selectedSubject.id,
          code: this.selectedSubject.subjectCode,
          name: this.selectedSubject.subjectName,
          subjectFullName: this.selectedSubject.subjectFullName
        } : null,
        subjectCode: this.selectedSubject ? this.selectedSubject.subjectCode : this.subjectCode,
        summary: this.summary,
        sortType: this.sortType,
      };

      if (this.$refs.periodPopover) {
        this.$refs.periodPopover.doClose();
      }
      // 仅在确定时传递所有参数
      this.$emit('confirm', params);
    },
    // ========== 修改结束 ==========
    loadSubjectSelect() {

    }
  },
  watch: {
    subjectList: {
      immediate: true, // 组件初始化时立即执行
      handler(newVal) {
        this.allSubjects = newVal; // 直接使用父组件传递的数据
      }
    },
    currentSubject: {
      immediate: true, // 初始化时立即执行
      handler(newSubject) {
        if (newSubject && newSubject.code && newSubject.name) {
          // 同步到组件的选中状态和输入框显示
          this.selectedSubject = {
            subjectCode: newSubject.code,
            subjectName: newSubject.name,
            id: newSubject.id,
            ...newSubject
          };
          this.subjectCode = `${newSubject.code} ${newSubject.name}`;
        } else {
          // 清空选中状态
          this.selectedSubject = null;
          this.subjectCode = '';
        }
      }
    },
    startMonth(val) {
      if (!val) {
        const defaultDate = new Date();
        this.startMonth = defaultDate;
        this.endMonth = defaultDate;
        this.$message.warning('会计期间不可删除，请重新选择');
        this.handleDateChange();
      }
    },
    endMonth(val) {
      if (!val) {
        this.endMonth = this.startMonth || new Date();
        this.$message.warning('会计期间不可删除，请重新选择');
        this.handleDateChange();
      }
    }
  },
  mounted() {
    const defaultDateStr = this.currentAccountSets.currentAccountDate;
    const defaultDate = this.parseDateStrToDate(defaultDateStr);
    const normalizedDate = new Date(defaultDate.getFullYear(), defaultDate.getMonth(), 1, 0, 0, 0, 0);

    this.startMonth = normalizedDate;
    this.endMonth = normalizedDate;
    this.displayDate = this.formatDate(normalizedDate)
    this.handleDateChange();

  }
};
</script>

<style scoped lang="less">
/* 完全保持原始样式，未做任何修改 */
.subject-input-width {
  width: 100%;
  position: relative;
}

::v-deep .subject-input-width .el-autocomplete-suggestion {
  border-radius: 4px !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid #e4e7ed !important;
  padding: 5px 0 !important;
  margin-top: 2px !important;
  z-index: 9999 !important;
}

::v-deep .subject-input-width .el-autocomplete-suggestion__item {
  padding: 8px 15px !important;
  line-height: 1.5 !important;

  &:hover {
    background-color: #f5f7fa !important;
  }

  &.current {
    background-color: #e6f7ff !important;
    color: #1890ff !important;
  }
}

::v-deep .subject-input-width .el-autocomplete-suggestion__list {
  max-height: 250px !important;
  overflow-y: auto !important;
}

::v-deep .subject-selected .el-autocomplete-suggestion {
  display: none !important;
}

::v-deep .subject-input-width .el-input {
  position: relative;
  z-index: 1;
}

::v-deep .subject-input-width .el-input__suffix-inner .el-icon-circle-close {
  vertical-align: middle;
  line-height: 1;
  cursor: pointer;
}

::v-deep .el-input--clearable:not(.is-focus):not(.is-hover) .el-input__clear {
  display: none !important;
}

.subject-option {
  display: flex;
  align-items: center;
  width: 100%; /* 确保选项占满容器宽度 */
  box-sizing: border-box;
}

/* 科目编码区域：固定宽度，超出也省略，确保对齐 */
.subject-option__code {
  width: 100px; /* 编码区域宽度可随下拉框加宽适当调大，也可保持不变 */
  flex-shrink: 0; /* 禁止收缩，保持固定宽度 */
  color: #1890ff !important;
  font-family: monospace;
  margin-right: 10px;
  padding-right: 10px;
  border-right: 1px solid #eee;
  white-space: nowrap; /* 禁止换行 */
  overflow: hidden; /* 溢出隐藏 */
  text-overflow: ellipsis; /* 溢出显示省略号 */
}

/* 科目名称区域：占剩余宽度，长文本省略 */
.subject-option__name {
  flex: 1; /* 占满剩余宽度 */
  white-space: nowrap; /* 禁止换行 */
  overflow: hidden; /* 溢出隐藏 */
  text-overflow: ellipsis; /* 溢出显示省略号 */
  padding-right: 5px; /* 预留一点间距，避免省略号贴边 */
}

/* 核心修改：调大下拉建议框的宽度（min-width/max-width/width） */
::v-deep .subject-input-width .el-autocomplete-suggestion {
  border-radius: 4px !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid #e4e7ed !important;
  padding: 5px 0 !important;
  margin-top: 2px !important;
  z-index: 9999 !important;
  min-width: 400px; /* 你调整后的宽宽度 */
  max-width: 600px;
  box-sizing: border-box;
  overflow-x: hidden !important; /* 强制禁用水平滚动条（关键） */
  overflow-y: visible !important; /* 让内部列表自己管理垂直滚动 */
}

/* 2. 建议列表内容容器：仅保留垂直滚动，禁用水平滚动 */
::v-deep .subject-input-width .el-autocomplete-suggestion__list {
  // 保留你发现的临界高度（250px内，比如240px，避免触发水平滚动）
  max-height: 240px !important;
  overflow-y: auto !important; // 保留垂直小滚动条
  overflow-x: hidden !important; // 双重保险：即使高度偶尔超出，也不会出现水平长滚动条
  padding: 0 !important;
}

// 外层容器双保险：彻底禁止水平滚动
::v-deep .subject-input-width .el-autocomplete-suggestion {
  overflow-x: hidden !important; // 杜绝外层触发水平长滚动条
}

::v-deep .subject-input-width .el-input__suffix {
  top: 50% !important;
  transform: translateY(-50%) !important;
}

::v-deep .subject-input-width .el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
}

.green-date-display {
  min-width: 120px;
  max-width: 300px;
  width: auto !important;
  display: inline-block;
  text-align: center;
  line-height: 32px;
  border-radius: 4px;
  transition: all 0.2s ease;
  background-color: #3788ee !important;
  color: #fff !important;
  padding: 0 12px;
  cursor: pointer;
}

::v-deep .account-period-popover {
  border-radius: 8px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
  border: none !important;
  overflow: hidden;
  box-sizing: border-box !important;
}

::v-deep .account-period-popover .el-popover__content {
  width: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
}

.account-period-form {
  font-size: 14px;
  color: #333;
  background-color: #fff;
  width: 100% !important;
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  background-color: #e6f7ff !important;
  border-bottom: 1px solid #e4e7ed;
}

.form-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #1f2329;
}

.form-header .close-btn {
  color: #909399;
  background: transparent;
  border: none;
  width: 24px;
  height: 24px;
  padding: 0;
  border-radius: 50%;
  transition: all 0.2s;
}

.form-header .close-btn:hover {
  background-color: #e9ecef;
  color: #606266;
}

.form-content {
  padding: 15px 30px;
  width: 100% !important;
  box-sizing: border-box !important;
}

.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  transition: all 0.2s;
}

.form-item:last-child {
  margin-bottom: 0;
}

.form-label {
  width: 90px;
  text-align: right;
  margin-right: 15px;
  color: #606266;
  font-weight: 500;
  line-height: 32px;
}

.form-control {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
}

/deep/ .date-picker.el-date-editor .el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
  padding-right: 36px !important;
  font-size: 14px;
}

/deep/ .date-picker.el-date-editor .el-input__icon {
  font-size: 14px !important;
  color: #999;
  width: auto !important;
  margin: 0 !important;
  padding: 0 !important;
  position: absolute !important;
  top: 50% !important;
  transform: translateY(-47%) !important;
  right: -15px !important;
  line-height: 1 !important;
}

.date-picker {
  border-radius: 4px;
  margin: 0 !important;
}

.to {
  color: #909399;
  padding: 0 2px;
  line-height: 32px !important;
  font-size: 14px;
}

.radio-group .el-radio {
  margin-right: 20px;
  color: #606266;
}

.radio-group .el-radio:last-child {
  margin-right: 0;
}

.radio-group .el-radio .el-radio__label {
  padding-left: 5px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  padding: 12px 30px;
  background-color: #e6f7ff !important;
  border-top: 1px solid #e4e7ed;
  gap: 10px;
}

.action-btn {
  padding: 6px 15px;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.2s ease;
}

.action-btn.confirm-btn {
  background-color: #409eff;
  border-color: #409eff;
}

.action-btn.confirm-btn:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

.action-btn.cancel-btn {
  background-color: #fff;
  border-color: #dcdfe6;
  color: #606266;
}

.action-btn.cancel-btn:hover {
  background-color: #f5f5f5;
}

.action-btn.reset-btn {
  background-color: #f5f7fa;
  border-color: #dcdfe6;
  color: #606266;
}

.action-btn.reset-btn:hover {
  background-color: #e9ecef;
}

/deep/ .el-popover-fade-enter-active,
/deep/ .el-popover-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

/deep/ .el-popover-fade-enter,
/deep/ .el-popover-fade-leave-to {
  opacity: 0;
  transform: translateY(5px);
}

/deep/ .el-input__inner {
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  box-shadow: none;
  transition: border-color 0.2s ease-in-out;
}

/deep/ .el-input__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

/deep/ .el-date-editor:focus-within .el-input__inner,
/deep/ .el-input-number:focus-within .el-input__inner {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}
</style>